import { MessageProcessingIcon } from './MessageProcessingIcon';

/**
 * author: Google
 * id 602EE454-C61C-4608-919E-FCCF3B58DE65
 * name message-processing
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-processing.svg
 * tags
 */
export const TextsmsIcon = MessageProcessingIcon;
export default TextsmsIcon